import { Button } from '@mantine/core'

export default Button.extend({
    defaultProps: { variant: 'filled', size: 'md' },

    /** When defining variant styles that are already in use by Mantine (filled, outline, etc), defining the vars resolver instead of
     * classNames guarantees that our styles/tokens will always win over Mantine's definitions. */
    vars: (_, { disabled, variant, size }) => {
        const defaultRoot = {
            '--button-radius': '3px',
            '--button-bd': 'none',
            '--button-height': size === 'sm' ? '34px' : '44px',
            '--button-padding-x': size === 'sm' ? '16px' : '24px',
            '--button-fz': size === 'sm' ? '0.75rem' : '0.875rem',
            fontWeight: 'var(--gm-weight-text-bold)',
            lineHeight: size === 'sm' ? '18px' : '120%',
        }

        const subtleVariantRoot = {
            ...defaultRoot,
            '--button-color': 'var(--mercy-primary)',
            '--button-bg': 'white',
            '--button-hover': '#e8eff1',
        }

        switch (variant) {
            case 'filled': {
                return {
                    root: {
                        ...defaultRoot,
                        '--button-color': 'white',
                        '--button-hover-color': 'white',
                        '--button-bg': 'var(--mercy-bg-blue)',
                        '--button-hover': 'var(--mercy-bg-blue-hover)',
                    },
                }
            }
            case 'outline': {
                return {
                    root: {
                        ...subtleVariantRoot,
                        border: !disabled ? '1px solid var(--mercy-primary)' : undefined,
                    },
                }
            }
            case 'subtle': {
                return {
                    root: subtleVariantRoot,
                }
            }
            default: {
                return { root: defaultRoot }
            }
        }
    },
})
